import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { EASE } from './Reveal';

/* First visit only: the Blue Block logo draws in with a quick counter, then the curtain lifts (~1s) */
export default function Preloader() {
  const [show, setShow] = useState(() => {
    try { return !sessionStorage.getItem('bb_intro'); } catch { return true; }
  });
  const [pct, setPct] = useState(0);

  useEffect(() => {
    if (!show) return undefined;
    document.documentElement.style.overflow = 'hidden';
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min(100, Math.round(((now - start) / 520) * 100));
      setPct(p);
      if (p < 100) raf = requestAnimationFrame(tick);
      else setTimeout(() => { setShow(false); try { sessionStorage.setItem('bb_intro', '1'); } catch { /* ignore */ } }, 60);
    };
    raf = requestAnimationFrame(tick);
    return () => { cancelAnimationFrame(raf); document.documentElement.style.overflow = ''; };
  }, [show]);

  useEffect(() => { if (!show) document.documentElement.style.overflow = ''; }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div className="preloader" initial={{ y: 0 }} exit={{ y: '-100%' }} transition={{ duration: 0.6, ease: [0.76, 0, 0.24, 1] }}>
          <motion.div className="pl-logo" initial={{ opacity: 0, scale: 0.6, filter: 'blur(10px)' }} animate={{ opacity: 1, scale: 1, filter: 'blur(0px)' }} transition={{ duration: 0.45, ease: EASE }}>
            <img src="/logo-160.png" alt="" width="96" height="96" />
            <span className="pl-shine" />
          </motion.div>
          <motion.div className="pl-text" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15, duration: 0.7, ease: EASE }}>
            <strong>Blue Block</strong><span>Project Management Consultancy</span>
          </motion.div>
          <div className="pl-count">{String(pct).padStart(3, '0')}</div>
          <div className="pl-bar"><i style={{ transform: `scaleX(${pct / 100})` }} /></div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
